module.exports = __webpack_public_path__ + "img/vipon-loading.d6f565c5.svg";